import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Solid background color override; if omitted, uses the muted token. */
  background?: string;
  /** Foreground color for solid backgrounds; defaults to white. */
  foreground?: string;
}

/** Small label chip — used for polygon-type tags in the sidebar. */
export const Pill = React.forwardRef<HTMLSpanElement, PillProps>(
  ({ className, style, background, foreground, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex max-w-full items-center rounded-md px-1.5 text-[10px] font-semibold leading-[18px] tracking-wide truncate',
        background ? '' : 'bg-muted text-muted-foreground',
        className
      )}
      style={{
        ...(background ? { background, color: foreground ?? 'white' } : null),
        ...style,
      }}
      {...props}
    >
      {children}
    </span>
  )
);
Pill.displayName = 'Pill';
